const resizeObserver = new ResizeObserver(entries => {
  for (const entry of entries) {
    // arbitrarily chosen out of content- and border-boxSize
    if (entry.contentBoxSize) {
      // run the imported callback function
      cb();
    }
  }
});

let cb; // make cb available to the whole scope.

const resize = ({selector, callback, active}) => {
  const elements = document.querySelectorAll(selector);
  // we only want to run if we have both something to check against, and something to run once we detect a change.
  if (!elements.length || !typeof callback === 'function') return false;
  cb = callback;
  elements.forEach(el => {
    if (active) {
      resizeObserver.observe(el);
    } else {
      resizeObserver.unobserve(el);
    }
  });
}

export {
  resize
}